export default "__VITE_ASSET__CIPiW4CA__"